import Handlebars from 'handlebars';
import {stripHTML} from 'util/StringUtil';


export const getStringRepresentation = (p, templateId) => {
	if (!p) return '';
	let templateString = stripHTML(getPersonTemplateString(templateId));
	return getPersonInfoRepresentation(templateString, 'p')({p});
}

export const getHTMLRepresentation = (p, templateId) => {
	if (!p) return '';
	let templateString = getPersonTemplateString(templateId)
	return getPersonInfoRepresentation(templateString, 'p')({p});
};

function getPersonTemplateString(templateId) {
	let strTemplateId = templateId + '';
	switch (strTemplateId) {
		case '0':
			return '{{vorname}} {{zuname}} <span class="FloatRight"><small>{{persNr}}</small></span>';
		case '1':
			return '{{zuname}} {{vorname}} <span class="FloatRight"><small>{{persNr}}</small></span>';
		case '2':
			return '{{vorname}} {{zuname}}';
		case '3':
			return '{{zuname}} {{vorname}}';
		default:
			return strTemplateId;
	}
}

export function wrapTemplateWithSelPanTemplate(templateId) {
	let templateString = getPersonTemplateString(templateId);

	return '<div class="{{visibleClass}} {{disabledClass}}">' +
		'<div class="SelPanEntryLabel">' +
		'<i class="SelPanLiIcon {{myselfClass}} fa-2x"></i> ' +
		'<div class="SelPanEntryTemplate">' + templateString + '</div>'
		+
		'</div>' +
		'<i data-name="spinner" class="SelPanLiSpinner"></i>' +
		'</div>';
}

export function getPersonInfoRepresentation(templateString, context = "") {
	registerHelper('with');

	let mapTemplate = `{{#with ${context}}}${templateString}{{/with}}`
	return Handlebars.compile(mapTemplate);
}

function registerHelper(apiContext) {
	if (apiContext) Handlebars.registerHelper(apiContext, function (context, options) {
		return options.fn(context);
	});

}